import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import RegisterRef from './pages/auth/RegisterRef';
import ReferByRegister from './pages/auth/ReferByRegister';
import Dashboard from './pages/user/Dashboard';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminLayout from './pages/layouts/AdminLayout';
import UserLayout from './pages/layouts/UserLayout';
import Wallets from './pages/user/Wallets';
import Cards from './pages/user/Cards';
import Transactions from './pages/user/Transactions';
import SumsubKyc from './pages/auth/SumsubKyc';
import Reports from './pages/user/Reports';
import ForgotPassword from './pages/auth/ForgotPassword';
import Profile from './pages/auth/Profile';
import { Toaster } from 'react-hot-toast';
import EmailPreview  from './pages/Emails/EmailPreview';

function App() {
    return (
        <>
            <Toaster
                position="top-center"
                reverseOrder={false}
                toastOptions={{
                    // Default options for all toasts
                    duration: 3000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                    },
                    // Configure different types of toasts
                    success: {
                        duration: 3000,
                        theme: {
                            primary: '#4aed88',
                        },
                    },
                    error: {
                        duration: 4000,
                        theme: {
                            primary: '#ff4b4b',
                        },
                    },
                }}
            />
            <Router>
                <div className="App">
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<RegisterRef />} />
                        <Route path="/registerReffer" element={<RegisterRef />} />
                        <Route path="/register-refer-xpd" element={<ReferByRegister />} />
                        <Route path="/email-preview" element={<EmailPreview />} />


                        {/*forgot password*/}
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route
                            path="/profile"
                            element={
                                <ProtectedRoute>
                                    <UserLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Profile />} />
                        </Route>
                        {/* User Protected Routes */}
                        <Route
                            path="/kyc-verify"
                            element={
                                <ProtectedRoute>
                                    <UserLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<SumsubKyc />} />
                        </Route>
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <UserLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Dashboard />} />
                        </Route>
                        <Route
                            path="/wallets"
                            element={
                                <ProtectedRoute>
                                    <UserLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Wallets />} />
                        </Route>

                        <Route
                            path="/cards"
                            element={
                                <ProtectedRoute>
                                    <UserLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Cards />} />
                        </Route>

                        <Route
                            path="/transactions"
                            element={
                                <ProtectedRoute>
                                    <UserLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Transactions />} />
                        </Route>

                        <Route
                            path="/reports"
                            element={
                                <ProtectedRoute>
                                    <UserLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Reports />} />
                        </Route>

                        {/* Admin Protected Routes */}
                        <Route
                            path="/admin/dashboard"
                            element={
                                <AdminProtectedRoute>
                                    <AdminLayout />
                                </AdminProtectedRoute>
                            }
                        >
                            <Route index element={<AdminDashboard />} />
                        </Route>

                        {/* Redirect to login if no routes matched */}
                        <Route path="*" element={<Navigate to="/login" />} />
                    </Routes>
                </div>
            </Router>
        </>


    );
}

export default App;